export const languageQuestionTypes = [
    { code: 'p-vocabulary', label: 'Vocabulary' },
    { code: 'reading-comprehension', label: 'Reading Comprehension' },
    { code: 'critical-thinking', label: 'Critical Thinking' },
    { code: 'parallel-reasoning', label: 'Parallel Reasoning' },
    { code: 'paragraph-writing', label: 'Paragraph Writing' },
    { code: 'image-describing', label: 'Image Describing' },
    { code: 'paragraph-improvement', label: 'Paragraph Improvement' },
    { code: 'paragraph-summary', label: 'Paragraph Summary' },
]